import React from 'react'
import styled from 'styled-components'
import FadeInUpWrapper from '../../common/FadeInUpWrapper'


const Body = styled(FadeInUpWrapper)`
  width: 650px;
  background: white;
  box-shadow: 0 4px 10px -2px rgba(0,0,0,0.3);
  padding: 20px;
  display: flex;
  font-size: 16px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  span {
    padding: 20px 0 40px 0;
    text-align: center;
  }
`

const Button = styled.button`
  font-size: 14px;
  line-height: 14px;
  height: 40px;
  font-weight: 200;
  padding: 7px 10px;
  border-radius: 4px;
  border: none;
  width: 70px;
  margin: 15px 10px;
  color: white;
  background-color: #DC6A00;
`

const Icon = styled.i`
  border-radius: 50%;
  margin-top: 30px;
  border: none;
  color: white;
  height: 60px;
  width: 60px;
  display: flex;
  line-height: 60px;
  font-size: 45px;
  justify-content: center;
  align-items: center;
  background-color: #00B178;
  padding: 5px;
  margin-left: 4px;
  margin-right: 10px;
`

const Title = styled.h3`
  font-size: 1.2rem !important;
  font-weight: 400 !important;
  margin: 1rem !important;
`

const Subtitle = styled.p`
  text-wrap: pretty;
  margin: 1rem !important;
`

export default class RequestSentModal extends React.Component {
  render() {
    const { toggleModal } = this.props

    return (
      <Body id="request_sent_modal">
        <Icon className="fa fa-check" />
        <Title>Your signature request was sent successfully!</Title>
        <Subtitle>
          The signer(s) have been emailed a link to sign the documents. If only
          one signer was requested, that signer can also sign the document by
          signing into their application
        </Subtitle>
        <Button id="close_request_sent" onClick={toggleModal}>Done</Button>
      </Body>
    )
  }
}